import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A subtle fade + rise applied to routed page content on every navigation (Design System V2 §5
 * Motion — "page fade transitions"). Keyed by pathname so React remounts (and thus re-animates)
 * the wrapper on each route change; `prefers-reduced-motion` is handled globally
 * (`styles/global.css` forces near-zero animation duration for every user with that preference).
 */
export function PageTransition({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();

  return (
    <Box
      key={pathname}
      sx={{
        animation: 'willnq-page-fade 240ms cubic-bezier(0, 0, 0.2, 1)',
        '@keyframes willnq-page-fade': {
          from: { opacity: 0, transform: 'translateY(6px)' },
          to: { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      {children}
    </Box>
  );
}
